export function SectionHeading({ kicker, title, text }: { kicker?: string; title: string; text?: string }) {
  return (
    <div className="mb-8 max-w-3xl">
      {kicker ? <span className="badge mb-4">{kicker}</span> : null}
      <h2 className="text-3xl font-extrabold tracking-normal text-navy md:text-5xl">{title}</h2>
      {text ? <p className="mt-4 text-lg leading-8 text-slate-600">{text}</p> : null}
    </div>
  );
}
